export function applyPdfStyle(clone, doc, originalElement) {
	clone.classList.add('pdf-export');

	clone.querySelector('#actions')?.remove();
	clone.querySelector('#logos')?.remove();

	replaceQrCanvasWithImage(clone, doc, originalElement);

	clone.prepend(buildPdfStyleTag(doc));
}

// QR code: canvas não sobrevive ao cloneNode, precisa converter pra imagem
function replaceQrCanvasWithImage(clone, doc, originalElement) {
	const qr = originalElement.querySelector('canvas');
	const cloneQr = clone.querySelector('canvas');
	if (!qr || !cloneQr) return;

	cloneQr.replaceWith(
		Object.assign(doc.createElement('img'), {
			src: qr.toDataURL('image/png'),
			width: 200,
			height: 200
		})
	);
}

function buildPdfStyleTag(doc) {
	const style = doc.createElement('style');
	style.textContent = `
		.pdf-export {
			width: 800px !important;
			font-family: 'Poppins', sans-serif !important;
			background: #fff !important;
			padding: 30px 30px !important;
			box-sizing: border-box !important;
			color: #000 !important;
		}

		.pdf-export h1,
		.pdf-export h2,
		.pdf-export h3,
		.pdf-export p,
		.pdf-export .text-center {
			text-align: center !important;
		}

		.pdf-export h1 {
			font-size: 28px !important;
			font-weight: 600 !important;
		}

		.pdf-export h2 {
			font-size: 21px !important;
			font-weight: 600 !important;
		}

		.pdf-export h3 {
			font-size: 16.38px !important;
			font-weight: 700 !important;
		}

		.pdf-export h3.mb-4 {
			margin-bottom: 16px !important;
		}

		.pdf-export p {
			font-size: 15px !important;
			margin: 4px 0 !important;
		}

		.pdf-export strong,
		.pdf-export b {
			font-weight: 700 !important;
			font-size: 15px !important;
		}

		.pdf-export hr {
			border: none !important;
			border-top: 1px solid #ddd !important;
			margin: 20px 0 !important;
		}

		.pdf-export ul,
		.pdf-export ol {
			text-align: left !important;
			font-size: 12px !important;
			line-height: 1.6 !important;
			padding-left: 20px !important;
			margin: 8px 0 !important;
		}

		.pdf-export li {
			margin-bottom: 4px !important;
		}

		.pdf-export img,
		.pdf-export canvas {
			display: block !important;
			margin: 16px auto !important;
		}

		.pdf-export .justify-end,
		.container-comprovante .justify-end {
			display: flex !important;
			text-align: right !important;
			justify-content: end !important;
		}

		.pdf-export .my-4 {
			margin-top: 16px !important;
    		margin-bottom: 16px !important;
		}

		.container-comprovante p {
			text-transform: uppercase;
			line-height: 1.2 !important;
		}

		.text-caption {
			font-size: 0.75rem !important;
			font-weight: 400;
			line-height: 1.25rem;
			letter-spacing: 0.0333333333em !important;
			text-align: right !important;
		}
	`;
	return style;
}